import { Box, BoxProps } from "@mui/material";
import TextBase from "src/commonStyles/text/textBase/textBase";

const PRODUCT_PREFIXES = [
    "sản phẩm bảo hiểm liên kết chung",
    "sản phẩm bảo hiểm liên kết đơn vị",
];

interface ProductNameProps {
    value?: string;
    className?: string;
    textAlign?: BoxProps["textAlign"];
}

const splitProductName = (prdName?: string) => {
    if (!prdName) return null;

    const lowerName = prdName.toLowerCase();

    const matchedPrefix = PRODUCT_PREFIXES.find(prefix =>
        lowerName.includes(prefix)
    );

    if (!matchedPrefix) return null;

    const index = lowerName.indexOf(matchedPrefix);

    return {
        prefix: prdName.slice(index, index + matchedPrefix.length),
        remain: prdName.slice(index + matchedPrefix.length).trim(),
    };
};

const ProductName = ({ value, className, textAlign = "right" }: ProductNameProps) => {
    const result = splitProductName(value);

    if (!result) {
        return <TextBase className={className}>{value}</TextBase>;
    }

    return (
        <Box textAlign={textAlign}>
            {result.prefix && (<TextBase
                className={`${className ?? ""} !text-gray-400 !text-[11px]`}
            >
                {result.prefix}
            </TextBase>)}

            {result.remain && (
                <TextBase className={className}>
                    {result.remain}
                </TextBase>
            )}
        </Box>
    );
};

export default ProductName;
